module.exports = __webpack_public_path__ + "static/media/arrow_right_icon.d9cafefd.svg";